export class SmartphotoImageBase {
    name = 'name.jpg?test';
    type = 'type';
    caption = 'caption';
    takePhotoAt;
    uuid = 'uuid';
    coordinates = [0, 0];
    AI = {};
    number;
    vehiclePart = 'front';
    constructor(image) {
        Object.entries(image).forEach(([key, value]) => {
            this[key] = value;
        });
    }
}
